import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TPositionType {
  id: number;
  name: string;
  valid: boolean;
  dataSource: string;
}

export interface IPositionType extends TPositionType {}

const PositionType = Model(
  (model: TPositionType): IPositionType => {
    const _positionType: TPositionType = Object.assign({}, model);

    let create = (positionTypes: IPositionType): IPositionType => {
      let obj = ValidatableObject(positionType);
      return obj;
    };

    let positionType = {
      get id() {
        return _positionType.id;
      },
      set id(value) {
        _positionType.id = value;
      },
      get name() {
        return _positionType.name;
      },
      set name(value) {
        _positionType.name = value;
      },
      get valid() {
        return _positionType.valid;
      },
      set valid(value) {
        _positionType.valid = value;
      },
      get dataSource() {
        return _positionType.dataSource;
      },
      set dataSource(value) {
        _positionType.dataSource = value;
      }
    };

    return create(positionType);
  }
);

export default PositionType;
